export const Routes = [{
  path: '/login',
  title: '登录',
  component: () => import('@/views/login/Login'),
  children: [],
}, {
  path: '/change-password',
  title: '修改密码',
  component: () => import('@/views/user/ChangePassword'),
  children: [],
}, {
  path: '/',
  icon: "ios-home",
  title: '首页',
  component: () => import('@/layouts/OnlyHeaderLayout'),
  children: [{
    path: '/abc',
    icon: "ios-home",
    title: '首页',
    component: () => import('@/views/Abc/CreateAbc'),  
  }, {
    path: '/404',
    title: '页面消失',
    component: () => import('@/layouts/NotFound'),
  }],
}]
